let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2xU5R")).then(() => parcelRequire('2OSP3'));